import { render, staticRenderFns } from "./ResponseChip.vue?vue&type=template&id=49d29954&scoped=true&"
import script from "./ResponseChip.vue?vue&type=script&lang=js&"
export * from "./ResponseChip.vue?vue&type=script&lang=js&"
import style0 from "./ResponseChip.vue?vue&type=style&index=0&id=49d29954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d29954",
  null
  
)

export default component.exports